import moment from 'moment'

export function isPast(date?: string): boolean {
  if (!date) {
    return false
  }

  return moment(date).isBefore(moment(`${moment().format('MM/DD/yyyy')} 00:00:00`))
}
